var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{attrs:{"dense":""}},[_c('v-col',[_c(_vm.tab.component,{tag:"component",attrs:{"disabled":_vm.disabled,"data":_vm.model},on:{"update:data":function($event){_vm.model=$event}}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }